// ── Tool View diagnostics query hook (FR-TOOL-001 — SA-only, READ-ONLY) ──────
// GET /tools/diagnostics is NOW LIVE and SUPER-ADMIN ONLY (coaching.tools.view.org,
// migration 0227, plus a defense-in-depth role==='super_admin' check). It returns
// provider-gate states + outbox health counts + non-secret config flags. NO SECRET
// VALUES are present (every secret-bearing var is a configured/not-configured
// boolean; secretsRedacted:true). The read flows through useHonestQuery so a denial
// / outage / gate renders an honest posture — never a blank. `enabled` gates the
// fetch so the query NEVER fires for a non-super-admin (fail-closed).

import { useHonestQuery } from "../components/honest-state";
import type { HonestQueryResult } from "../components/honest-state/useHonestQuery";
import { getCoachingReadinessServices } from "../services/coaching-service-provider";
import type { CoachingToolViewDiagnosticsDto } from "../services/coaching-readiness-dtos";
import { coachingQueryKeys } from "./coaching-query-keys";

export function useToolViewDiagnostics(enabled: boolean): HonestQueryResult<CoachingToolViewDiagnosticsDto> {
  return useHonestQuery<CoachingToolViewDiagnosticsDto>(
    coachingQueryKeys.readiness.toolDiagnostics(),
    () => getCoachingReadinessServices().tools.diagnostics(),
    {
      enabled,
      errorPath: "/tools/diagnostics",
      // The diagnostics body is an object (never a bare list); it is never "empty".
      isEmpty: () => false
    }
  );
}
